export const state = {
  top5Computers: [],
  top5ComputersError: "",
  top5Groups: [],
  eventTrends: [],
  topComputers: [],
  blocksOverTime: [],
  alertSummary: [],
  companyOverview: [],
  knownThreads: [],
  numberOfBlocksByTime: [],
  companyOverviewLoading: false,
  alertSummaryLoading: false,
  knownThreadsLoading: false,
  top5GroupsLoading: false,
  top5ComputersLoading: false,
};

export type State = typeof state;
